export function capitalize(word: string | undefined | null): string {
    return !word ? '' : word.slice(0, 1).toUpperCase() + word.slice(1);
}

export function deselectTextInput(e: React.FocusEvent) {
    if (e.target instanceof HTMLInputElement) e.target?.setSelectionRange(0, 0);
}
